export class ApiError extends Error {
  constructor (message, state) {
    super(message)
    this.msg = message
    this.state = state
  }
}



// WEBPACK FOOTER //
// ./src/common/api/error.js